export type TNativeConstantSourceNode = ConstantSourceNode;
